import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessageService } from '../_services/message.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MustMatch } from '../_helpers/MustMatch';
import { MustNotMatch } from '../_helpers/MustNotMatch';
import { Location } from '@angular/common';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  fmGroup: FormGroup;
  disable = false;

  constructor(
              private authenticationService: AuthenticationService,
              private messageService: MessageService,
              private userService: UserService,
              private location: Location,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    const maxLength = Validators.minLength(6);
    this.userService.esFederada().subscribe(res => {
      this.disable = res;
      if(res)
        this.messageService.sendMessage("Información", "Tu login fue con una cuenta externa, para cambiar tu contraseña debes hacerlo por ese medio.", null, "info");
    });
    this.fmGroup = this.fb.group({
      password: ['', [Validators.required, maxLength]],
      newPassword: ['', [Validators.required, maxLength]],
      confirmpassword: ['', [Validators.required, maxLength]]
    }, {
      validator: [
        MustMatch('newPassword', 'confirmpassword'),
        MustNotMatch('password', 'newPassword')
      ]
    });
  }

  back(){
    this.location.back();
  }

  onResetPassword() {
    this.authenticationService.modifyPassword(this.fmGroup.value.password, this.fmGroup.value.newPassword, this.fmGroup.value.confirmpassword).subscribe(o => {
      this.messageService.sendMessage('Modificación de Contraseña', 'Su contraseña ha sido modificada exitosamente.', 0, 'info');
      this.back();
    }, error => {
      switch (error.status) {
        case 401:
        case 409:
          this.messageService.sendMessage('<h2>Error</h2>', error.error, 0, 'danger');
          break;
        default:
          this.messageService.sendErrorMessage();
          break;
      }
      
    });
  }
}
